import { ToastService } from '../../state/toast/toast.service';

export const validUpload = async (file: File, toastService: ToastService): Promise<boolean> => {
  try {
    // arrayBuffer() will throw if underlying file is not available
    await file.arrayBuffer();
    return true;
  } catch {
    toastService.showToast({
      type: 'error',
      message: $localize`File ${file.name} is not available. Has it been renamed or deleted?`,
      duration: 0,
    });
    return false;
  }
};
